import styled from 'styled-components';
import CandidateListCard from '../CandidateListCard';

export const CandidateCard = styled(CandidateListCard)`
  background-color: transparent;
`;
